import { logoImage } from '@quickbit/qb-design-system';
import { jsPDF } from 'jspdf';
import { useCallback, useState } from 'react';
import { Order } from 'tabs/types';

export interface Args {
  order: Order;
}

export const useGenerateProofPDF = () => {
  const [error, setError] = useState(false);

  const generateProofPDF = useCallback(({ order }: Args) => {
    try {
      const { amount, currency, uuid, completedAt, createdAt, merchant } =
        order;

      //PDF generation starts here
      const pdf = new jsPDF();
      const createdAtDate = new Date(createdAt);
      const completedAtDate = completedAt
        ? new Date(completedAt).toLocaleString()
        : '';
      let sectionStart = 0;

      pdf.addImage({
        imageData: logoImage,
        x: 150,
        y: 11,
        width: 50,
        height: 12,
        format: 'WEBP',
        compression: 'FAST',
      });
      pdf.setFontSize(22);
      pdf.text('Proof of payment', 10, 19);
      pdf.setFontSize(10);
      pdf.text(
        `Date: ${new Date().toLocaleString('default', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        })}`,
        10,
        25
      );
      pdf.line(9, 27, 202, 27);

      //Sender, Receiver details section
      // Headings
      sectionStart = 35;
      pdf.setFont(pdf.getFont().fontName, 'bold');
      pdf.text('Order Id:', 10, sectionStart);
      pdf.text('Receiver Name:', 110, sectionStart, { align: 'left' });
      pdf.text('Receiver Id:', 110, sectionStart + 5, { align: 'left' });

      // Values
      pdf.setFont(pdf.getFont().fontName, 'normal');
      pdf.text(uuid, 30, sectionStart);
      pdf.text(merchant.name || ' - ', 145, sectionStart, {
        align: 'left',
      });
      pdf.text(merchant.uuid || ' - ', 135, sectionStart + 5, {
        align: 'left',
      });

      // Horizontal line
      pdf.line(105, sectionStart - 5, 105, sectionStart + 10);
      //Section break line
      pdf.line(9, sectionStart + 13, 202, sectionStart + 13);

      sectionStart = 60;
      pdf.setFontSize(10);
      pdf.setFont(pdf.getFont().fontName, 'bold');
      pdf.text('Order Amount:', 10, sectionStart - 7);
      pdf.text('Order Date:', 10, sectionStart - 3);
      pdf.text('Completion Date:', 10, sectionStart + 1);

      const finalAmount = `${amount.toString()} ${currency}`;
      pdf.setFont(pdf.getFont().fontName, 'normal');
      pdf.text(finalAmount, 42, sectionStart - 7);
      pdf.text(createdAtDate.toLocaleString(), 42, sectionStart - 3);
      pdf.text(completedAtDate, 42, sectionStart + 1);
      pdf.line(9, sectionStart + 4, 202, sectionStart + 4);

      //This will download the pdf automatically
      pdf.save(
        `${merchant.name.replaceAll(
          ' ',
          '_'
        )}-${createdAtDate.toLocaleDateString()}.pdf`
      );
    } catch (e) {
      console.error(e);
      setError(true);
    }
  }, []);

  return { generateProofPDF, error, setError };
};
